/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Advanced_BadgeInputs */

const en_audio_description_export_advanced_badge = /** @type {(inputs: Audio_Description_Export_Advanced_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced`)
};

const fr_audio_description_export_advanced_badge = /** @type {(inputs: Audio_Description_Export_Advanced_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avancé`)
};

const de_audio_description_export_advanced_badge = /** @type {(inputs: Audio_Description_Export_Advanced_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschrittlich`)
};

const it_audio_description_export_advanced_badge = /** @type {(inputs: Audio_Description_Export_Advanced_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzato`)
};

const ru_audio_description_export_advanced_badge = /** @type {(inputs: Audio_Description_Export_Advanced_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передовой`)
};

const es_audio_description_export_advanced_badge = /** @type {(inputs: Audio_Description_Export_Advanced_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzado`)
};

const zh_cn2_audio_description_export_advanced_badge = /** @type {(inputs: Audio_Description_Export_Advanced_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先进的`)
};

const ja_audio_description_export_advanced_badge = /** @type {(inputs: Audio_Description_Export_Advanced_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高度な`)
};

const hi_audio_description_export_advanced_badge = /** @type {(inputs: Audio_Description_Export_Advanced_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विकसित`)
};

const pt_pt2_audio_description_export_advanced_badge = /** @type {(inputs: Audio_Description_Export_Advanced_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avançado`)
};

/**
* | output |
* | --- |
* | "Advanced" |
*
* @param {Audio_Description_Export_Advanced_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_advanced_badge = /** @type {((inputs?: Audio_Description_Export_Advanced_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Advanced_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_advanced_badge(inputs)
	if (locale === "de") return de_audio_description_export_advanced_badge(inputs)
	if (locale === "it") return it_audio_description_export_advanced_badge(inputs)
	if (locale === "ru") return ru_audio_description_export_advanced_badge(inputs)
	if (locale === "es") return es_audio_description_export_advanced_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_advanced_badge(inputs)
	if (locale === "ja") return ja_audio_description_export_advanced_badge(inputs)
	if (locale === "hi") return hi_audio_description_export_advanced_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_advanced_badge(inputs)
	return en_audio_description_export_advanced_badge(inputs)
});